import SitecoreImageModel from '@models/SitecoreImageModel';
import SitecoreLinkModel from '@models/SitecoreLinkModel';
import SitecoreTextModel from '@models/SitecoreTextModel';

export default class BannerWithRichTextOverlayFieldsModel {
  constructor() {
    this['Background Image'] = new SitecoreImageModel();

    this['Mobile Background Image'] = new SitecoreImageModel();

    this['CTA Button Link'] = new SitecoreLinkModel();

    this['CTA Button Text'] = new SitecoreTextModel();

    this.Description = new SitecoreTextModel();

    this.Title = new SitecoreTextModel();
  }

  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Background Image')) {
      this['Background Image'].getData(dataSource['Background Image']);
    }

    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Mobile Background Image')) {
      this['Mobile Background Image'].getData(dataSource['Mobile Background Image']);
    }

    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'CTA Button Link')) {
      this['CTA Button Link'].getData(dataSource['CTA Button Link']);
    }

    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'CTA Button Text')) {
      this['CTA Button Text'].getData(dataSource['CTA Button Text']);
    }

    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Description')) {
      this.Description.getData(dataSource.Description);
    }

    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Title')) {
      this.Title.getData(dataSource.Title);
    }

    return this;
  }
}
